module.exports = __webpack_public_path__ + "static/banner_ouvidoria-652ca70504d71649c4e40565e82a94a9.jpeg";